import type { PropertyPath } from "lodash"
import get from "lodash/get"
import isEqual from "lodash/isEqual"

export const shouldUpdateWithSpecificProps = <Props>({
  nextProps,
  props,
  updateOn,
}: {
  nextProps: Props
  props: Props
  updateOn: PropertyPath[]
}): boolean => {
  return Boolean(
    updateOn.find((path: PropertyPath) => {
      return !isEqual(get(props, path), get(nextProps, path))
    })
  )
}
